export enum WebsiteModalTypeEnum {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
  SITEMAP = 'sitemap',
  ALL_PAGES = 'all-pages',
  YOUTUBE = 'youtube',
}
